import teakAsset from "@/assets/products/flexible-wall-cladding-teak.webp.asset.json";
import walnutAsset from "@/assets/products/flexible-wall-cladding-walnut.webp.asset.json";
import wallAsset from "@/assets/products/flexible-wall-cladding-teak-walnut-wall.webp.asset.json";
import curvedNaturalAsset from "@/assets/products/flexible-wall-cladding-curved-natural.webp.asset.json";
import curvedWalnutAsset from "@/assets/products/flexible-wall-cladding-curved-walnut.webp.asset.json";
import profileAsset from "@/assets/products/flexible-wall-cladding-profile.webp.asset.json";

export const FLEXIBLE_WALL_CLADDING_IMAGES = {
  teak: teakAsset.url,
  walnut: walnutAsset.url,
  wall: wallAsset.url,
  curvedNatural: curvedNaturalAsset.url,
  curvedWalnut: curvedWalnutAsset.url,
  profile: profileAsset.url,
};

export interface FlexibleWallCladdingProduct {
  id: string;
  name: string;
  colour: string;
  sku: string;
  description: string;
  price: number;
  image: string;
  gallery: string[];
  width: string;
  length: string;
  size: string;
  thickness: string;
  shopifyVariantId: string;
  soldOut?: boolean;
}

const SHARED_GALLERY = [
  FLEXIBLE_WALL_CLADDING_IMAGES.wall,
];


export const FLEXIBLE_WALL_CLADDING_PRODUCTS: FlexibleWallCladdingProduct[] = [
  {
    id: "flexible-wall-cladding-teak",
    name: "Flexible Wall Cladding - Teak",
    colour: "Teak",
    sku: "FWC-TEAK-300-2700-12",
    description:
      "Premium flexible wall cladding panel with a natural timber appearance. Designed for interior feature walls, curved surfaces, and decorative applications.",
    price: 70,
    image: FLEXIBLE_WALL_CLADDING_IMAGES.teak,
    gallery: [
      FLEXIBLE_WALL_CLADDING_IMAGES.teak,
      FLEXIBLE_WALL_CLADDING_IMAGES.curvedNatural,
      ...SHARED_GALLERY,
    ],
    width: "300mm",
    length: "2700mm",
    size: "300mm × 2700mm",
    thickness: "12mm",
    shopifyVariantId: "gid://shopify/ProductVariant/48100000000011",
  },
  {
    id: "flexible-wall-cladding-walnut",
    name: "Flexible Wall Cladding - Walnut",
    colour: "Walnut",
    sku: "FWC-WALNUT-300-2700-12",
    description:
      "Elegant walnut-look flexible wall panel designed to create warm, modern interiors with a premium timber finish.",
    price: 70,
    image: FLEXIBLE_WALL_CLADDING_IMAGES.walnut,
    gallery: [
      FLEXIBLE_WALL_CLADDING_IMAGES.walnut,
      FLEXIBLE_WALL_CLADDING_IMAGES.curvedWalnut,
      ...SHARED_GALLERY,
    ],
    width: "300mm",
    length: "2700mm",
    size: "300mm × 2700mm",
    thickness: "12mm",
    shopifyVariantId: "gid://shopify/ProductVariant/48100000000012",
  },
];

export const FLEXIBLE_WALL_CLADDING_SPECS: { label: string; value: string }[] = [
  { label: "Product Type", value: "Flexible Wall Cladding" },
  { label: "Width", value: "300mm" },
  { label: "Length", value: "2700mm" },
  { label: "Thickness", value: "12mm" },
  { label: "Colours Available", value: "Teak, Walnut" },
  { label: "Price", value: "$70 each" },
  { label: "Application", value: "Indoor Walls" },
];

export const FLEXIBLE_WALL_CLADDING_APPLICATIONS = [
  "Living room feature walls",
  "TV walls",
  "Bedrooms",
  "Offices",
  "Restaurants",
  "Retail interiors",
  "Commercial spaces",
  "Curved wall designs",
];

export const FLEXIBLE_WALL_CLADDING_INSTALLATION = [
  "Ensure the wall surface is clean and level",
  "Panels can be cut to the required size",
  "Use a suitable adhesive or fixing method according to the substrate",
  "Professional installation recommended for complex curved applications",
];

export const FLEXIBLE_WALL_CLADDING_FAQS = [
  {
    question: "What is flexible wall cladding?",
    answer:
      "Flexible wall cladding is an interior wall panel designed to create decorative timber-look surfaces and can adapt to curved or feature wall applications.",
  },
  {
    question: "What sizes are available?",
    answer: "Panels are available in 300mm width × 2700mm length with 12mm thickness.",
  },
  {
    question: "What colours are available?",
    answer: "Available colours are Teak and Walnut.",
  },
  {
    question: "How much does flexible wall cladding cost?",
    answer: "The price is $70 per panel.",
  },
  {
    question: "Where can flexible wall cladding be used?",
    answer: "Suitable for homes, offices, retail spaces, restaurants, and commercial interiors.",
  },
];
